import React from 'react';
import { IPage } from 'src/interfaces';
import { Container, MessageContainer, Title } from './styles';

const NotFound: React.FC<IPage> = () => (
  <Container>
    <MessageContainer>
      <Title>Page not found</Title>
    </MessageContainer>
  </Container>
);

export default NotFound;
